import React from 'react';

import { IIconProps } from '@icons/interface';

const ErrorPlateIcon = (props?: IIconProps) => {
	const color = props?.innerSvgProps?.color || '#2E2E6B';
	const activeColor = props?.innerSvgProps?.fill;

	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M15.4219 3H8.57813C8.48074 2.99966 8.38424 3.01853 8.29415 3.05553C8.20407 3.09253 8.12216 3.14694 8.05313 3.21563L3.21563 8.05313C3.14694 8.12216 3.09253 8.20407 3.05553 8.29415C3.01853 8.38424 2.99966 8.48074 3 8.57813V15.4219C2.99966 15.5193 3.01853 15.6158 3.05553 15.7058C3.09253 15.7959 3.14694 15.8778 3.21563 15.9469L8.05313 20.7844C8.12216 20.8531 8.20407 20.9075 8.29415 20.9445C8.38424 20.9815 8.48074 21.0003 8.57813 21H15.4219C15.5193 21.0003 15.6158 20.9815 15.7058 20.9445C15.7959 20.9075 15.8778 20.8531 15.9469 20.7844L20.7844 15.9469C20.8531 15.8778 20.9075 15.7959 20.9445 15.7058C20.9815 15.6158 21.0003 15.5193 21 15.4219V8.57813C21.0003 8.48074 20.9815 8.38424 20.9445 8.29415C20.9075 8.20407 20.8531 8.12216 20.7844 8.05313L15.9469 3.21563C15.8778 3.14694 15.7959 3.09253 15.7058 3.05553C15.6158 3.01853 15.5193 2.99966 15.4219 3V3Z'
				stroke={color}
				strokeMiterlimit='10'
				{...props?.isActive ? { fill: color } : {}}
			/>
			<path
				d='M12 7.5V12.75'
				stroke={props?.isActive ? activeColor : color}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z'
				fill={props?.isActive ? activeColor : color}
			/>
		</svg>
	);
};

export default ErrorPlateIcon;
